module.exports = __webpack_public_path__ + "img/schools.f4f75991.svg";